import { CSSProperties } from 'react';

import { AppColors } from '../../theme';

type ContentCardStyles = {
  contentCard: CSSProperties;
  contentCard__col: CSSProperties;
  contentCard__value: CSSProperties;
  contentCard__deliveryDate: CSSProperties;
  contentCard__showmore: CSSProperties;
};

const styles: ContentCardStyles = {
  contentCard: {
    backgroundColor: AppColors.VA.NEUTRALS.WHITE,
    border: 0,
    borderRadius: '8px',
    padding: '16px',
    gap: '24px',
    color: AppColors.VA.PRIMARY._90_
  },
  contentCard__col: {
    display: 'flex',
    flexDirection: 'column',
    color: AppColors.VA.PRIMARY._90_
  },
  contentCard__value: {
    whiteSpace: 'normal',
    color: AppColors.VA.PRIMARY._90_
  },
  contentCard__deliveryDate: {
    color: AppColors.VA.PRIMARY._50_,
    backgroundColor: `${AppColors.VA.PRIMARY._50_}1A`,
    gap: '10px',
    padding: '9px 16px',
    borderRadius: '8px'
  },
  contentCard__showmore: {
    color: AppColors.VA.PRIMARY._50_
  }
};

export default styles;
